import plyr from 'plyr';
window.Plyr = plyr;